import { Component, OnInit, Input } from '@angular/core';
import { WriteLogsService } from '../../../../services/write-logs.service';
import { CyclistService } from '../../../../services/cyclist.service';
import { PageViews } from '../../../../enums/page-views.enum';
import { HelpersService } from '../../../../services/helpers.service';
import { NotificationService } from '../../../../services/notification.service';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { CommunicationService } from '../../../../services/communication.service';

@Component({
  selector: 'app-messaging',
  templateUrl: './messaging.component.html',
  styleUrls: ['./messaging.component.scss'],
})
export class MessagingComponent implements OnInit {
  public header: string;
  public text: string;
  public sendingState: string;
  public notifications: any = [];
  public loading = false;
  public showLoader = true;
  public sending = false;
  public countryData: any = {};
  public isWhatsappCustomMessageWindowOpen: boolean = false;
  public whatsappFeatureEnabled: boolean = false;
  public hasInitiateChatTemplate: boolean = false;
  public busyInitiatingChat: boolean = false;
  public defaultMessageType: string = 'SMS';

  public interval: any = null;

  @Input() jobcard;
  @Input() messageService;

  constructor(
    private writeLogsService: WriteLogsService,
    private cyclistService: CyclistService,
    private helperService: HelpersService,
    private notificationService: NotificationService,
    private translate: TranslateService,
    private communicationService: CommunicationService,
  ) { }

  ngOnInit() {
    this.showLoader = true;
    this.countryData = this.helperService.getCountryData();
    this.writeLogsService
      .writeLog(PageViews.MESSAGES_TAB, this.jobcard.ID)
      .subscribe((result) => { });
    this.getNotifications();
    this.checkIfWhatsappCustomMessageWindowOpen();
    this.getMessagesForCustomer();
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }

  getNotifications() {
    this.loading = true;
    this.notificationService
      .getJobCardNotificationsV2(this.jobcard.PartnerID, this.jobcard.ID)
      .subscribe((notifications) => {
        this.notifications = notifications.reverse();
        this.cleanDate();
        this.loading = false;
        setTimeout(() => {
          this.updateScroll();
        }, 100);
      });
  }
  checkIfWhatsappCustomMessageWindowOpen() {
    this.notificationService.checkIfWhatsappCustomMessageWindowOpen(this.jobcard.PartnerID, "JOBCARD", this.jobcard.ID).subscribe(res => {
      this.whatsappFeatureEnabled = res.useWhatsappFeatures;
      this.isWhatsappCustomMessageWindowOpen = res.isMessageWindowOpen;
      this.hasInitiateChatTemplate = res.hasInitiateChatTemplate;
      if (this.whatsappFeatureEnabled && (this.hasInitiateChatTemplate || this.isWhatsappCustomMessageWindowOpen)) {
        this.defaultMessageType = "WHATSAPP";
      }
    })
  }

  sendInitiateWhatsappChatTemplate() {
    this.busyInitiatingChat = true;
    this.notificationService.sendInitiateWhatsappChatTemplate(this.jobcard.PartnerID, "JOBCARD", this.jobcard.ID).subscribe(res => {
      this.getNotifications();
      this.busyInitiatingChat = false;
      //Check again in 5 seconds, allow time for delivery and webhooks to finish
      setTimeout(() => {
        this.getNotifications();
        this.sending = false;
      }, 5000);
    }, err => {
      this.busyInitiatingChat = false;
    })
  }

  //To fix the timezone issue :(
  cleanDate() {
    this.notifications.forEach((notification) => {
      notification.CreatedDate = notification.CreatedDate + 'Z';
    });
  }

  updateScroll() {
    var element = document.getElementById('notification-container');
    element.scrollTop = element.scrollHeight;
  }

  sendMessage() {
    if (
      this.text &&
      this.text.length > 0 &&
      this.sendingState !== 'Sending...'
    ) {
      this.sendingState = 'Sending...';
      this.sending = true;
      this.cyclistService
        .sendWorkshopMessage({
          Message: this.text,
          PartnerID: this.jobcard.PartnerID,
          JobcardID: this.jobcard.ID,
          ForceSMS: this.defaultMessageType == "SMS" ? true : false
        })
        .subscribe(
          (res) => {

            this.text = '';

            this.messageService.add({
              life: 5000,
              detail: this.translate.instant('messages.message_queued')
            });
            this.getNotifications();
            this.sending = false;
            this.sendingState = '';

            //Check again in 5 seconds, allow time for delivery and webhooks to finish
            setTimeout(() => {
              this.getNotifications();
              this.sending = false;
              this.sendingState = '';
            }, 5000);
          },
          (error) => {
            this.sending = false;
            this.sendingState = 'Error...';
            this.messageService.add({
              life: 5000,
              detail: this.translate.instant('messages.error_sending_message'),
            });
          },
        );
    }
  }

  //q: Create a function that will call the getMessagesForCustomer function in the communicatioService every 30 seconds
  getMessagesForCustomer() {
    this.interval = setInterval(() => {
      //console.log(this.jobcard);
      this.showLoader = false;
      this.communicationService
        .getNewMessagesForCustomer(this.jobcard.PartnerID, this.jobcard.CyclistID)
        .subscribe((res) => {
          this.getNotifications();
        });
    }, 15000);
  }

}
